export default __webpack_public_path__ + "static/screen_3_04.js-4ca29f92f98f6dcc5c5934d1f012ed25.svg";